@if (showDate() && companyFlagComposite().company_flag.flag_date) {
  <p class="text-muted small mb-1">
    {{ companyFlagComposite().company_flag.flag_date | date: 'mediumDate' }}
  </p>
}

@if (showHeader()) {
  <h6 class="fw-bold mb-1" [class.small]="compact()">
    {{ 'company_flag.' + companyFlagComposite().company_flag_type.company_flag_type_key | translate }}
  </h6>
}

@if (showDescription()) {
  <p class="text-muted small mb-2">
    {{
      'company_flag_type_description.' + companyFlagComposite().company_flag_type.company_flag_type_key
        | translateFallback: companyFlagComposite().company_flag_type.company_flag_type_description
    }}
  </p>
}

@if (showEvidence() && contextListLinks.length > 0) {
  @if (compact()) {
    <div class="small mb-0 context-hover text-decoration-underline"
      [popover]="compactPopover"
      [outsideClick]="true"
      placement="bottom"
      container="body">
      @for (entityData$ of contextListLinks; track $index) {
        @if ($index < (contextListLinks.length <= 2 ? 2 : 1)) {
          @if (entityData$) {
            @if (!(entityData$ | async)) {
              <nk-spinner display="inline"></nk-spinner>
            }
            @if (entityData$ | async; as entityData) {
              <div class="compact-context-text" [class.compact-context-text-single-line]="contextListLinks.length > 1">
                {{ entityData.title | translate }}
                @if (entityData.underTitle) {
                  <span class="text-muted ms-1">{{ entityData.underTitle }}</span>
                }
              </div>
            }
          }
        }
      }
      @if (remainingCount > 0) {
        <span>+{{ remainingCount }} {{ 'common.more' | translate }}</span>
      }
    </div>
    <ng-template #compactPopover>
      <ul class="text-start mb-0 ps-3">
        @for (entityData$ of contextListLinks; track $index) {
          @if (entityData$) {
            @if (entityData$ | async; as entityData) {
              <li>
                @if (entityData.internalUrl) {
                  <a [routerLink]="[entityData.internalUrl]"> {{ entityData.title | translate }} </a>
                } @else if (entityData.externalUrl) {
                  <a href="{{ entityData.externalUrl }}"> {{ entityData.title | translate }} </a>
                } @else {
                  {{ entityData.title | translate }}
                }
                @if (entityData.underTitle) {
                  <span class="text-muted ms-1">{{ entityData.underTitle }}</span>
                }
              </li>
            }
          }
        }
      </ul>
    </ng-template>
  } @else {
    <ul>
      @for (entityData$ of contextListLinks; track $index) {
        @if (entityData$) {
          <li>
            @if (!(entityData$ | async)) {
              <nk-spinner display="inline"></nk-spinner>
            }
            @if (entityData$ | async; as entityData) {
              @if (entityData.internalUrl) {
                <a [routerLink]="[entityData.internalUrl]"> {{ entityData.title | translate }} </a>
              }
              @if (entityData.externalUrl && !entityData.internalUrl) {
                <a href="{{ entityData.externalUrl }}"> {{ entityData.title | translate }} </a>
              }
              @if (!(entityData.externalUrl || entityData.internalUrl)) {
                {{ entityData.title | translate }}
              }
              <br />
              <span class="text-muted">{{ entityData.underTitle }}</span>
            }
          </li>
        }
      }
    </ul>
  }
}
